import { CurriculumType } from "../../models/modelTypes";
import { getData } from "./rest";

export const getVerbalPicks = async (): Promise<CurriculumType[]> => await getData("/home/verbal-picks");

export const getTopTen = async (): Promise<CurriculumType[]> => await getData("/home/top-curriculums");

export const getCurriculumsAZ = async (): Promise<CurriculumType[]> => await getData("/home/curriculums-az");
